export function initScrollProgress(): void {
  const progress = document.getElementById("progress");
  const nav = document.getElementById("nav");
  if (!progress || !nav) return;

  function onScroll(): void {
    const h = document.documentElement;
    const pct = (h.scrollTop / (h.scrollHeight - h.clientHeight)) * 100;
    progress!.style.width = pct + "%";
    nav!.classList.toggle("scrolled", h.scrollTop > 60);
  }

  window.addEventListener("scroll", onScroll, { passive: true });
  onScroll();
}
